<template>
  <div class="company-description">
    <div class="company-description__container">

      <UiHeader
        :header="$t('investor.mainPage.descriptionSection.title')"
        position="center"
        header-size="h5"
        header-size-tablet="h5"
        header-size-mobile="h7"
      />

      <div class="company-description__content">
        <div class="company-description__image-container">
          <picture>
            <source
              media="(min-width: 1600px)"
              srcset="/images/investor/main-page/company_ldesktop.png"
            >

            <source
              media="(min-width: 1200px)"
              srcset="/images/investor/main-page/company_desktop.png"
            >

            <source
              media="(min-width: 768px)"
              srcset="/images/investor/main-page/company_tablet.png"
            >

            <img
              class="company-description__image"
              src="/images/investor/main-page/company_mobile.png"
              :alt="$t('investor.mainPage.descriptionSection.altSectionImage')"
            >
          </picture>

          <img
            class="company-description__logo"
            src="/images/investor/main-page/logo.png"
            :alt="$t('investor.mainPage.descriptionSection.altLogo')"
          >
        </div>

        <div class="company-description__text">
          <h4 class="company-description__subtitle">
            {{ $t('investor.mainPage.descriptionSection.subtitle') }}
          </h4>

          <p class="company-description__description">
            {{ $t('investor.mainPage.descriptionSection.description1') }}
          </p>

          <p
            class="company-description__description"
            v-html="$t('investor.mainPage.descriptionSection.description2')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.company-description {
  display: grid;
  @include section-investor();

  &__container {
    @include section-investor__container();
  }

  &__image-container {
    position: relative;
    width: fit-content;
    margin: auto;
  }

  &__image {
    width: 28.2rem;
    height: 21.8rem;
    border-radius: 1.6rem;
  }

  &__logo {
    position: absolute;
    bottom: -31px;
    left: -33px;
  }

  &__text {
    margin-top: 7.2rem;
  }

  &__subtitle {
    @include h8;
    margin-bottom: 2.4rem;
    color: $text-400;
  }

  &__description {
    @include body-1;
    color: $text-400;

    &:last-of-type {
      margin-top: 1.2rem;
    }

    :deep(span) {
      @include body-1-medium;
    }
  }

  @include atXS {

    &__image {
      width: 49.4rem;
      height: 40.4rem;
      border-radius: 1.6rem;
    }
    
    &__logo {
      bottom: -45px;
      left: -38px;
    }

    &__text {
      margin-top: 9.6rem;
    }
  }

  @include atM {

    &__content {
      display: grid;
      align-items: center;
      grid-auto-flow: column;
      gap: 8rem;
    }

    &__image {
      width: 40rem;
      height: 32.8rem;
    }

    &__text {
      margin-top: 0;
    }

    &__logo {
      bottom: -36px;
      left: -30px;
    }
  }

  @include atXL {
    &__content {
      gap: 12rem;
    }

    &__image {
      width: 50rem;
      height: 38rem;
    }
  }
}
</style>
